<template>
  <div
    class="h5nav"
    v-if="
      navFlags.is_show_game ||
        navFlags.is_show_fans_group ||
        navFlags.is_show_cs
    "
  >
    <div @click="openGamelist" v-if="navFlags.is_show_game">
      <img
        v-if="pageName != 'gamelist_h5'"
        src="@/assets/images/h5/icon2.png"
        alt=""
      />
      <img
        v-if="pageName == 'gamelist_h5'"
        src="@/assets/images/h5/icon6.png"
        alt=""
      />
      <p :class="pageName == 'gamelist_h5' ? 'pcolor' : ''">
        {{ $t("h5page.footernav.text1") }}
      </p>
    </div>
    <div v-if="navFlags.is_show_fans_group" @click="openFanslist">
      <img
        v-if="pageName != 'fansH5'"
        src="@/assets/images/h5/icon3.png"
        alt=""
      />
      <img
        v-if="pageName == 'fansH5'"
        src="@/assets/images/h5/icon7.png"
        alt=""
      />
      <p :class="pageName == 'fansH5' ? 'pcolor' : ''">
        {{ $t("h5page.footernav.text2") }}
      </p>
    </div>
    <div @click="openServe" v-if="navFlags.is_show_cs">
      <img
        v-if="pageName != 'serviceH5'"
        src="@/assets/images/h5/icon4.png"
        alt=""
      />
      <img
        v-if="pageName == 'serviceH5'"
        src="@/assets/images/h5/icon8.png"
        alt=""
      />
      <p :class="pageName == 'serviceH5' ? 'pcolor' : ''">
        {{ $t("h5page.footernav.text3") }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "h5nav",
  props: {
    pageName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      navFlags: {
        is_show_cs: 0,
        is_show_fans_group: 0,
        is_show_game: 0,
        is_show_invest: 0,
        is_show_news: 0,
      },
    };
  },
  mounted() {
    this.$apis.header
      .getNavList()
      .then((res) => {
        if (res.data.code == 0) {
          this.navFlags = Object.assign({}, res.data.data);
        } else {
          // 接口请求失败时展示客服
          this.navFlags.is_show_cs = 1;
        }
      })
      .catch(() => {
        // 接口请求失败时展示客服
        this.navFlags.is_show_cs = 1;
      });
  },
  methods: {
    openServe() {
      if (this.pageName == "serviceH5") return;
      this.$router.push({ path: "/service/h5" });
    },
    openGamelist() {
      if (this.pageName == "gamelist_h5") return;
      this.$router.push({ path: "/gamelist_h5" });
    },
    openFanslist() {
      if (this.pageName == "fansH5") return;
      this.$router.push({ path: "/fans_h5" });
    },
  },
};
</script>
<style lang="scss" scoped>
.h5nav {
  z-index: 1;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.48rem;
  background: white;
  box-shadow: 0px -1px 1px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  > div {
    flex: 1;
    height: 0.26rem;
    box-sizing: border-box;
    border-right: 1px solid #eeeeee;
    &:last-of-type(1) {
      border-right: none;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      margin-left: 0.07rem;
      font-size: 0.1rem;
      font-family: SourceHanSansCN;
      // font-weight: bold;
      color: #444444;
    }
    .pcolor {
      color: #2da2d4 !important;
    }
    img {
      width: 0.13rem;
      height: 0.14rem;
    }
  }
}
</style>
